<!-- <template>
  <div
    class="bigscreen"
    :style="{
      transform: `scale(${scalesNum}) translate(-50%,-50%)`,
      '-webkit-transform': `scale(${scalesNum}) translate(-50%,-50%)`,
      '-moz-transform': `scale(${scalesNum}) translate(-50%,-50%)`,
      '-o-transform': `scale(${scalesNum}) translate(-50%,-50%)`,
      '-ms-transform': `scale(${scalesNum}) translate(-50%,-50%)`,
      'width': `${width}px`,
      'height': `${height}px`,
    }"
  >
    <router-view />
    <div
      class="alert"
      v-if="showAlert"
      style="position: fixed;right: 0px;top: 0px; width: 100px;height: 100px;z-index: 999;"
    >
      <router-link
        :to="{
          name: 'BigScreen_4Page',
          params: {
            classificationParams: {
              register_number: data.register_number,
              vElevatorCode: data.v_elevator_code,
              v_building_id: data.v_building_id,
              event_id: data.event_id,
              v_address: data.v_address,
            },
          },
        }"
      >
        <img src="@/assets/bigscreen/alert.gif" style="width: 100%;" />
        <div>{{ data.event_id }}</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      // a:'111'
      // showAlert:this.$store.state.showAlert,
      scalesNum: 1,
      height: document.documentElement.clientHeight,
      top: 0,

      width:0,
      height:0,
    };
  },
  computed: {
    ...mapState(["showAlert", "data"]),
  },
  mounted() {
    // 计算缩放比例
    this.resize_window();
    window.addEventListener("resize", () => {
      this.resize_window();
    });
  },
  methods: {
    resize_window() {
      // debugger
      // 因为设计图是带2150*1200的，但是浏览器本身带顶部工具栏，所以缩放到时候稍微更小一点，这样不会有滚动条，这个值可以选择更大些，比如2300，这样左右两边会有空白
      let myWidth = document.documentElement.clientWidth;
      let myHeight = document.documentElement.clientHeight;
      console.log(document.documentElement.clientHeight);
      this.width = 3840;
      this.height = 2160;
      let marginTop = 0;
      if (myHeight / this.width !== 0 && myWidth / this.width / (myHeight / this.height) >= 1) {
        this.scalesNum = myHeight / this.height;
        // this.top = 0
      } else {
        this.scalesNum = myWidth / this.width;
        marginTop = (myHeight - (myWidth * 9) / 16) / 2;
        this.top = marginTop;
      }
    },
  },
};
</script>

<style lang="scss" scope>
// .bigscreen{
// 	height: 100%; background: #070f29 url("~@/assets/bigscreen/ruijin/bg.png") no-repeat center top; background-size: cover;
// }
.bigscreen {
  margin: 0;

  padding: 0;

  transform-origin: 0 0;

  background: #070f29 url("~@/assets/bigscreen/ruijin/bg.png") no-repeat center top; background-size: cover;

  position: absolute;

  width: 2150px;

  height: 1200px;

  left: 50%;
  top: 50%;

  overflow: hidden;
}
</style> -->


<template>
  <div
    class="bigscreen"
    :style="{
      transform: `scale(${scalesNum}) translate(-50%,-50%)`,
      '-webkit-transform': `scale(${scalesNum}) translate(-50%,-50%)`,
      '-moz-transform': `scale(${scalesNum}) translate(-50%,-50%)`,
      '-o-transform': `scale(${scalesNum}) translate(-50%,-50%)`,
      '-ms-transform': `scale(${scalesNum}) translate(-50%,-50%)`,
      'width': `${width}px`,
      'height': `${height}px`,
    }"
  >
    <router-view />
    <div
      class="alert"
      v-if="showAlert"
      :style="{
        position: 'fixed',
        right: '50px',
        top: '0px',
        width: `${alertWidth}px`,
        height: `${alertHeight}px`,
        zIndex: 999,
        transform: `scale(${alertScale})`,
        transformOrigin: 'top right'
      }"
    >
      <router-link
        :to="{
          name: 'BigScreen6_newPage',
          params: {
            classificationParams: {
              register_number: data.register_number,
              vElevatorCode: data.v_elevator_code,
              v_building_id: data.v_building_id,
              event_id: data.event_id,
              v_address: data.v_address,
            },
          },
        }"
        style="display: flex; flex-direction: column; align-items: center; text-decoration: none;"
      >
        <img src="@/assets/bigscreen/alert.gif" style="width: 100%;" />
        <div :style="{
          textAlign: 'center',
          marginTop: `${alertNameMarginTop}px`,
          fontSize: `${alertNameFontSize}px`,
          color: '#ff0000',
          fontWeight: 'bold',
          lineHeight: 1.4
        }">{{ data.v_address }}</div>
        <!-- <div :style="{
          textAlign: 'center',
          marginTop: `${alertIdMarginTop}px`,
          fontSize: `${alertIdFontSize}px`,
          color: '#ff0',
          lineHeight: 1.4
        }">事件ID: {{ data.event_id }}</div> -->
      </router-link>
    </div>
    <!-- 告警音频播放器 -->
    <audio ref="alarmAudio" @ended="onAudioEnded">
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      // a:'111'
      // showAlert:this.$store.state.showAlert,
      scalesNum: 1,
      top: 0,

      width: 0,
      height: 0,
      // 定义使用大尺寸的路由数组
      largeScreenRoutes: ['/homePage', '/bigScreen', '/dashboard', '/monitorPage','/BigScreen_2_New','/BigScreen6_new'], // 可以根据实际需要添加更多路由
      // 告警警铃尺寸配置
      alertWidth: 100,
      alertHeight: 140,
      alertScale: 1,
      alertNameFontSize: 18,
      alertIdFontSize: 16,
      alertNameMarginTop: 5,
      alertIdMarginTop: 5,
      // 告警音频状态
      isPlaying: false,
      isMuted: false,
    };
  },
  computed: {
    ...mapState(["showAlert", "data"]),
  },
  watch: {
    // 监听路由参数变化
    '$route.query': {
      handler(newQuery) {
        // 从URL参数获取宽高，如果没有则根据路由设置默认值
        this.width = parseInt(newQuery.width) || this.getDefaultWidth();
        this.height = parseInt(newQuery.height) || this.getDefaultHeight();
        this.$nextTick(() => {
          this.resize_window();
        });
      },
      immediate: true
    },
    // 监听告警状态，控制音频播放
    showAlert(newVal) {
      if (newVal) {
        this.startAlarm();
      } else {
        this.stopAlarm();
      }
    },
    // 监听路由变化
    '$route'(to, from) {
      // 如果路由在大屏和小屏间切换，更新默认尺寸
      const isToLarge = this.isLargeScreenRoute(to.path);
      const wasLarge = this.isLargeScreenRoute(from.path);
      
      if (isToLarge !== wasLarge) {
        if (!this.$route.query.width && !this.$route.query.height) {
          this.width = this.getDefaultWidth();
          this.height = this.getDefaultHeight();
          this.$nextTick(() => {
            this.resize_window();
          });
        }
      }
      
      // 路由变化时更新告警尺寸
      this.updateAlertSize();
      
      // 确保每次路由变化时都禁用滚动条（防止从其他页面返回时遗留滚动条）
      this.$nextTick(() => {
        this.disableBodyScroll();
        // 同时将页面滚动位置重置到顶部
        window.scrollTo(0, 0);
        if (document.documentElement) {
          document.documentElement.scrollTop = 0;
        }
        if (document.body) {
          document.body.scrollTop = 0;
        }
      });
    }
  },
  mounted() {
    // 初始化时从URL参数获取宽高
    this.width = parseInt(this.$route.query.width) || this.getDefaultWidth();
    this.height = parseInt(this.$route.query.height) || this.getDefaultHeight();
    
    // 初始化告警警铃尺寸
    this.updateAlertSize();
    
    // 计算缩放比例
    this.resize_window();
    window.addEventListener("resize", () => {
      this.resize_window();
      // 窗口大小变化时也更新告警尺寸
      this.updateAlertSize();
    });
    
    // 添加全局点击事件监听，用于解锁浏览器音频播放
    document.addEventListener('click', this.handleUserInteraction);
    document.addEventListener('touchstart', this.handleUserInteraction);
    
    // 禁用body滚动
    this.disableBodyScroll();
    document.body.classList.add('bigscreen-theme');
  },
  beforeDestroy() {
    document.body.classList.remove('bigscreen-theme');
    // 组件销毁时停止告警音频
    this.stopAlarm();
    // 移除事件监听
    document.removeEventListener('click', this.handleUserInteraction);
    document.removeEventListener('touchstart', this.handleUserInteraction);
    // 恢复body滚动
    this.enableBodyScroll();
  },
  methods: {
    // 开始告警（播放音频）
    startAlarm() {
      if (this.isMuted) return; // 静音状态下不自动播放
      if (this.isPlaying) return;
      this.playAudio();
    },
    // 播放音频
    playAudio() {
      try {
        const audio = this.$refs.alarmAudio;
        if (audio) {
          audio.src = require('@/assets/audio/alarm_n.aac');
          audio.muted = false;
          audio.loop = true; // 循环播放
          const playPromise = audio.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.isPlaying = true;
            }).catch(error => {
              console.warn('⚠️ 音频播放被浏览器阻止:', error.name, error.message);
              this.isPlaying = false;
            });
          } else {
            this.isPlaying = true;
          }
        }
      } catch (error) {
        console.error('❌ 播放告警音频出错:', error);
      }
    },
    // 停止告警音频
    stopAlarm() {
      const audio = this.$refs.alarmAudio;
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
        audio.loop = false;
      }
      this.isPlaying = false;
      this.isMuted = false;
    },
    // 音频播放结束回调
    onAudioEnded() {
      this.isPlaying = false;
    },
    // 用户交互解锁音频播放（浏览器策略要求）
    handleUserInteraction() {
      if (this.showAlert && !this.isPlaying && !this.isMuted) {
        this.playAudio();
      }
    },
    isLargeScreenRoute(path) {
      // 判断是否为使用大尺寸的路由
      return this.largeScreenRoutes.some(route => path && path.includes(route));
    },
    getDefaultWidth() {
      // 根据当前路由返回默认宽度
      return this.isLargeScreenRoute(this.$route.path) ? 3840 : 1920;
    },
    getDefaultHeight() {
      // 根据当前路由返回默认高度
      return this.isLargeScreenRoute(this.$route.path) ? 2160 : 1200;
    },
    resize_window() {
      // debugger
      // 因为设计图是带2150*1200的，但是浏览器本身带顶部工具栏，所以缩放到时候稍微更小一点，这样不会有滚动条，这个值可以选择更大些，比如2300，这样左右两边会有空白
      let myWidth = document.documentElement.clientWidth;
      let myHeight = document.documentElement.clientHeight;
      console.log(document.documentElement.clientHeight);

      const router =  ['/homePage'];

      let marginTop = 0;
      if (myHeight / this.width !== 0 && myWidth / this.width / (myHeight / this.height) >= 1) {
        this.scalesNum = myHeight / this.height;
        // this.top = 0
      } else {
        this.scalesNum = myWidth / this.width;
        marginTop = (myHeight - (myWidth * 9) / 16) / 2;
        this.top = marginTop;
      }
    },
    disableBodyScroll() {
      // 禁用body和html的滚动条
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    },
    enableBodyScroll() {
      // 恢复body和html的滚动条
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    },
    updateAlertSize() {
      // 根据当前路由判断是否为4K大屏，与getDefaultWidth/getDefaultHeight逻辑保持一致
      const is4K = this.isLargeScreenRoute(this.$route.path);
      
      if (is4K) {
        // 4K大屏使用更大的尺寸
        this.alertWidth = 200;
        this.alertHeight = 320;
        this.alertScale = 1;
        this.alertNameFontSize = 32;
        this.alertIdFontSize = 28;
        this.alertNameMarginTop = 10;
        this.alertIdMarginTop = 12;
      } else {
        // 普通屏幕使用默认尺寸
        this.alertWidth = 100;
        this.alertHeight = 140;
        this.alertScale = 1;
        this.alertNameFontSize = 18;
        this.alertIdFontSize = 16;
        this.alertNameMarginTop = 5;
        this.alertIdMarginTop = 5;
      }
    },
  },
};
</script>

<style lang="scss" scope>
// 必须保持非scoped(scope是笔误、实际生效为全局)：kit里是.bigscreen的后代选择器，要作用到子组件DOM
@import '@/styles/bigScreen/styles/kit.scss';

// 缩放后视口多出来的边也刷成深色
body.bigscreen-theme {
  background: #070f29 url("~@/assets/bigscreen/ruijin/bg.png") no-repeat center top; background-size: cover;
}

.bigscreen {
  margin: 0;

  padding: 0;

  transform-origin: 0 0;

  background: #070f29 url("~@/assets/bigscreen/ruijin/bg.png") no-repeat center top; background-size: cover;

  position: absolute;

  width: 2150px;

  height: 1200px;

  left: 50%;
  top: 50%;

  overflow: hidden;
}
</style>
